const PROJECT_DISPLAY_NAMES = {
    bennu: 'Media',
    odin: 'AI',
    hermes: 'Setup',
    health: 'Health',
};

export const PROJECT_OPTIONS = Object.entries(PROJECT_DISPLAY_NAMES).map(
    ([value, label]) => ({ value, label })
);

/**
 * Map internal hub project keys to user-facing labels.
 * Unknown keys fall back to the raw value.
 */
export function projectDisplayName(project) {
    if (project == null || project === '') return '';
    return PROJECT_DISPLAY_NAMES[project] ?? project;
}
